import React from 'react';

const PLANS = [
  {
    code: 'PLAN A',
    title: '成果報酬型',
    price: '初期 ¥50,000 + 達成日 ¥1,500/日',
    bullets: [
      '月額固定 ¥0',
      '3位以内達成日のみ課金',
      '月キャップ ¥45,000',
      '6ヶ月未達成は初期費用全額返金',
    ],
    badge: 'リスクゼロ',
    highlighted: false,
  },
  {
    code: 'PLAN B',
    title: 'バランス型',
    price: '初期 ¥30,000 + 月 ¥20,000',
    bullets: [
      '3位以内達成日 ¥1,000/日',
      '月キャップ ¥30,000',
      '12ヶ月独占契約',
      '安定収入＋成果報酬',
    ],
    badge: '推奨',
    highlighted: true,
  },
  {
    code: 'PLAN C',
    title: '独占型',
    price: '初期 ¥80,000 + 月 ¥60,000',
    bullets: [
      '成果報酬なし',
      '商圏完全独占',
      '同業種他社受注なし',
      '12ヶ月+自動更新',
    ],
    badge: 'LTV最大化',
    highlighted: false,
  },
];

const PlanCards: React.FC<{ mapsUrl?: string }> = ({ mapsUrl }) => (
  <section className="py-4">
    <div className="flex items-baseline justify-between mb-3 flex-wrap gap-2">
      <h3 className="text-[13px] font-semibold text-slate-900">サービスプラン</h3>
      <span className="text-[11px] text-slate-500">独占契約モデル / 同一エリア×同業種は1社のみ受託</span>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-3 mb-4">
      {PLANS.map(p => (
        <div key={p.code} className={`border-l-2 ${p.highlighted ? 'border-l-leaf-500' : 'border-l-slate-300'} pl-3`}>
          <div className={`text-[10px] font-semibold tracking-[0.08em] mb-1 ${p.highlighted ? 'text-leaf-700' : 'text-slate-500'}`}>
            {p.code} — {p.badge}
          </div>
          <h4 className="text-[13px] font-semibold text-slate-900 mb-1">{p.title}</h4>
          <div className="text-[11px] text-slate-500 mb-2">{p.price}</div>
          <ul className="text-[11px] text-slate-700 space-y-0.5 list-disc pl-4">
            {p.bullets.map((b, i) => <li key={i}>{b}</li>)}
          </ul>
        </div>
      ))}
    </div>

    <div className="bg-brand-500 text-white px-5 py-4 rounded">
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <div>
          <div className="text-[10px] text-white/70 mb-1 tracking-[0.08em] uppercase">ご検討に進む場合</div>
          <div className="text-[14px] font-semibold">「分析希望」とご返信ください。3分の現状分析動画をお送りします。</div>
        </div>
        {mapsUrl && (
          <a
            href={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[11px] px-3 py-1.5 bg-white/10 border border-white/30 rounded hover:bg-white/20"
          >
            Googleマップで現状確認
          </a>
        )}
      </div>
    </div>
  </section>
);

export default PlanCards;
